import {
  DownloadOutlined,
  FileTextOutlined,
  SyncOutlined
} from '@ant-design/icons';
import { Button, Col, Row, Space } from 'antd';
import { ButtonDeleteConfirm } from 'client/ui/button/ButtonDeleteConfirm';
import { IRequestFileValue } from 'common/schema/request/Request';
import { useField } from 'formik';
import React, { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { Typography } from 'antd';
import './UploadedFileField.scss';
import { getRequestAttachmentUrl } from './WidgetUploadInput';
import { useCurrentCitizen } from 'client/components/auth/AuthModule';

const { Text } = Typography;

export interface IUploadedFileFieldProps {
  name: string;
  ellipsis: number;
}

/** Permette un ellipse a circa 2/3 del titolo del testo */
function middleEllipse(text: string | undefined | null, maxLength: number) {
  if (!text) return text;
  if (text.length > maxLength) {
    const sideLength = Math.floor(maxLength / 3) - 1;
    return (
      text.substr(0, sideLength * 2) +
      '...' +
      text.substr(text.length - sideLength, text.length)
    );
  }
  return text;
}

/**
 * Mostra il singolo file caricato con la possibilità di eliminarlo per
 * ricaricare un nuovo file.
 * Solo per file singoli.
 */
export function UploadedFileField(props: IUploadedFileFieldProps) {
  const { name, ellipsis } = props;
  const [field, , helpers] = useField<IRequestFileValue>(name);
  const [filename, setFilename] = useState<string | undefined | null>(
    middleEllipse(field.value[0].fileName, ellipsis)
  );

  // Serve per sapere se si è effettuato il login o meno.
  const citizen = useCurrentCitizen();
  // Si può effettuare il download dell'allegato solo se si è autenticati.
  const canDownload = citizen != null;

  useEffect(() => {
    setFilename(middleEllipse(field.value[0].fileName, ellipsis));
  }, [field.value[0].fileName, ellipsis]);

  const handleRemove = useCallback(() => {
    helpers.setValue([]);
  }, [helpers]);

  if (field.value.length === 0) {
    return null;
  }

  return (
    <Row className="upload-file-field" align="middle" style={{ width: '100%' }}>
      <Col flex="auto">
        <Space
          direction="horizontal"
          size={4}
          align="center"
          style={{ fontSize: '16px' }}
        >
          <FileTextOutlined />
          <Text>{filename ?? <SyncOutlined spin />}</Text>
        </Space>
      </Col>
      {canDownload && (
        <Col>
          <a href={getRequestAttachmentUrl(field.value[0])} target="_blank">
            <Button type="primary" size="small" icon={<DownloadOutlined />} />
          </a>
        </Col>
      )}
      <Col flex={'0 0 40px'}>
        <ButtonDeleteConfirm
          className="attachement-delete-button"
          onConfirm={handleRemove}
          title={'Rimuovere il file?'}
          okText={'Rimuovi'}
          iconOnlyButton
          buttonDanger
          size="small"
        />
      </Col>
    </Row>
  );
}
